import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-custom" }
const _hoisted_2 = { class: "custom" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 6 }
const _hoisted_10 = { key: 7 }
const _hoisted_11 = { key: 8 }
const _hoisted_12 = { key: 9 }
const _hoisted_13 = { key: 10 }
const _hoisted_14 = { key: 11 }
const _hoisted_15 = { key: 12 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageBranch = _resolveComponent("MessageBranch")!
  const _component_MessageIMRobotWelcome = _resolveComponent("MessageIMRobotWelcome")!
  const _component_MessageForm = _resolveComponent("MessageForm")!
  const _component_MessageProductCard = _resolveComponent("MessageProductCard")!
  const _component_MessageRichText = _resolveComponent("MessageRichText")!
  const _component_MessageStream = _resolveComponent("MessageStream")!
  const _component_MessageMultiBranch = _resolveComponent("MessageMultiBranch")!
  const _component_MessageMultiForm = _resolveComponent("MessageMultiForm")!
  const _component_MessageRating = _resolveComponent("MessageRating")!
  const _component_MessageConcurrencyLimit = _resolveComponent("MessageConcurrencyLimit")!
  const _component_MessageOrder = _resolveComponent("MessageOrder")!
  const _component_MessageTransferWithDesc = _resolveComponent("MessageTransferWithDesc")!
  const _component_MessageQueueConfirmation = _resolveComponent("MessageQueueConfirmation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
          $setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.BRANCH ||
            $setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.BRANCH_NUMBER ||
            ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.ROBOT_MSG &&
              $setup.payload.subtype !== 'welcome_msg')
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_MessageBranch, {
              payload: $setup.payload,
              onSendMessage: $setup.sendTextMessage,
              onHeightChanged: $setup.onHeightChanged
            }, null, 8, ["payload", "onSendMessage", "onHeightChanged"])
          ]))
        : _createCommentVNode("", true),
      (
          $setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.ROBOT_MSG && $setup.payload.subtype === 'welcome_msg'
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_MessageIMRobotWelcome, {
              payload: $setup.payload,
              onSendMessage: $setup.sendTextMessage
            }, null, 8, ["payload", "onSendMessage"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.FROM_INPUT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_MessageForm, {
              payload: $setup.payload,
              onSendMessage: $setup.sendTextMessage
            }, null, 8, ["payload", "onSendMessage"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.PRODUCT_CARD)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_MessageProductCard, { payload: $setup.payload }, null, 8, ["payload"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.RICH_TEXT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_MessageRichText, {
              payload: $setup.payload,
              onHeightChanged: $setup.onHeightChanged
            }, null, 8, ["payload", "onHeightChanged"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.STREAM_TEXT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_MessageStream, {
              payload: $setup.payload,
              onHeightChanged: $setup.onHeightChanged
            }, null, 8, ["payload", "onHeightChanged"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.MULTI_BRANCH)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_MessageMultiBranch, {
              payload: $setup.payload,
              onSendMessage: $setup.sendTextMessage,
              onHeightChanged: $setup.onHeightChanged
            }, null, 8, ["payload", "onSendMessage", "onHeightChanged"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.MULTI_FORM && $props.message.flow == 'in')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_MessageMultiForm, {
              payload: $setup.payload,
              onSendMessage: $setup.sendCustomMessage,
              onShowFormPopup: $setup.handleShowFormPopup
            }, null, 8, ["payload", "onSendMessage", "onShowFormPopup"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.MENU)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_MessageRating, {
              message: $setup.props.message,
              onSendMessage: $setup.sendCustomMessage
            }, null, 8, ["message", "onSendMessage"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.CONCURRENCY_LIMIT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_MessageConcurrencyLimit)
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.ORDER)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_MessageOrder, { payload: $setup.payload }, null, 8, ["payload"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.TRANSFER_TO_HUMAN || $setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.TRANSFER_TO_TASK_FLOW)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_MessageTransferWithDesc, { payload: $setup.payload }, null, 8, ["payload"])
          ]))
        : _createCommentVNode("", true),
      ($setup.payload.src === $setup.CUSTOM_MESSAGE_SRC.QUEUE_CONFIRMATION)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_MessageQueueConfirmation, {
              payload: $setup.payload,
              onSendMessage: $setup.sendCustomMessage
            }, null, 8, ["payload", "onSendMessage"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}